import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import ProjectDetail from "./pages/ProjectDetail";
import ExperienceDetail from "./pages/ExperienceDetail";
import { Toaster } from "./components/ui/toaster";

function App() {
	return (
		<div className="App">
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Portfolio />} />
					<Route path="/projects/:slug" element={<ProjectDetail />} />
					<Route path="/experience/:slug" element={<ExperienceDetail />} />
				</Routes>
			</BrowserRouter>
			<Toaster />
		</div>
	);
}

export default App;
